import Image from "next/image";

import { cn } from "@/lib/utils";

const TOOL_ICONS: Array<{ src: string; alt: string; brand?: boolean }> = [
  { src: "/assets/read-cv-logo-white.svg", alt: "CV rewrite" },
  { src: "/assets/chats.svg", alt: "Mock interview" },
  { src: "/assets/target.svg", alt: "Ideal job fit" },
  // LinkedIn keeps its authentic brand logo (blue), rendered as its own tile.
  { src: "/assets/linkedin.svg", alt: "LinkedIn", brand: true },
  { src: "/assets/users-three.svg", alt: "Community" },
];

/**
 * Branded "in one pack" graphic for the Career OS Bundle. Not a product
 * screenshot: a deliberate brand panel that visualises the bundled tools as
 * uniform app-style tiles (brand-red tiles with white glyphs; LinkedIn keeps
 * its authentic logo).
 */
export function BundleVisual() {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-border-primary bg-white p-5 shadow-card dark:bg-card">
      <div className="space-y-0.5">
        <span className="text-lg font-bold tracking-tight text-text-heading">
          hy<span className="text-brand-primary">red.</span>
        </span>
        <p className="text-base font-semibold leading-tight text-text-heading">
          Career OS Bundle
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {TOOL_ICONS.map((tool) => (
          <span
            key={tool.src}
            className={cn(
              "flex size-10 items-center justify-center overflow-hidden rounded-lg",
              tool.brand ? "bg-white ring-1 ring-border-primary" : "bg-brand-primary",
            )}
          >
            <Image
              src={tool.src}
              alt={tool.alt}
              width={24}
              height={24}
              className={tool.brand ? "h-7 w-7" : "h-5 w-5"}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
